<template> 
  <div> 
    <div class="ms-4">
        <div class="page-title flex-row me-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('invoice_list') }}
            </h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-primary">{{ $t('reports') }}</li>   
                <li class="breadcrumb-item text-primary">{{ $t('financial_reports') }}</li>  
                <li class="breadcrumb-item text-gray-600">{{ $t('invoice_list') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li> 
            </ul> 
        </div>
    </div>  
    <div class="content flex-row-fluid mt-4" id="kt_content">
        <div class="card">            
            <div class="row fv-row border-0 pt-6 px-9">
                <div class="col-lg-10">
                    <div class="fv-row mb-4 row">  
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('report_type') }}</span>
                            </label>
                            <Select2 v-model="form.report_type" :options="reportTypes"  :settings="{ width: '100%' }"/>
                        </div>                        
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12" v-if="form.report_type == '2'">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('start_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12" v-if="form.report_type == '2'">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('end_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('currency') }}</span>
                            </label>
                            <Select2 v-model="form.currency" :options="currencyList" :settings="{width: '100%'}" />
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('invoice_type') }}</span>
                            </label>
                            <Select2 v-model="form.invoice_type" :options="invoiceTypeList" :settings="{width: '100%'}" />
                        </div> 
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('account') }}</span>
                            </label>
                            <Select2 v-model="form.account_id" :options="accountList"  :settings="{ width: '100%' }"/>
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('sales_vendor') }}</span>
                            </label>
                            <Select2 v-model="form.vendor_id" :options="salesVendorList"  :settings="{ width: '100%' }"/>
                        </div>
                        <div class="col-lg">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('remain_status') }}</span>
                            </label>
                            <Select2 v-model="form.remain_status" :options="isRemainStatusList" :settings="{width: '100%'}" />
                        </div>
                    </div>  
                </div>
                <div class="col-lg-2">
                    <div class="d-flex justify-content-end my-6" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(68,'R')"> 
                        <Popper hover placement="top">
                        <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                            <i class="bi bi-eraser-fill fs-4"> </i>
                        </button>
                        <template #content>
                            <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                        </template>
                    </Popper> 
                    <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on" >
                        <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                        <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                        <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                        </svg>
                        </span>
                        <span v-if="!this.isListProgressing"> {{ $t('list') }} </span> 
                        <span class="indicator-progress" v-if="this.isListProgressing">
                            {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span> 
                    </button> 
                    </div>
                </div>
            </div>
            <div class="card-body pt-3">
                <div class="separator my-3 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="row min-h-300px"> 
                        <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions>
                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true"
                            key-expr="id"
                            :data-source="lists"
                            :allow-column-reordering="true"
                            :allow-column-resizing="true"
                            :column-auto-width="true"
                            :row-alternatin-enabled="true"
                            :hover-state-enabled="true"
                            :show-row-lines="true"
                            @exporting="this.$onExporting($event , 'Invoice-Transaction-List')"
                            :ref="'dataGrid'"
                            :scrolling="{ mode: 'virtual' }"
                            :customize-columns="onCustomizeColumn">

                            <DxFilterRow :visible="true"/>
                            <DxHeaderFilter :visible="true"/>
                            <DxGroupPanel :visible="true"/>
                            <DxExport :enabled="false" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                            <DxPaging :page-size="10"/>
                            <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                            <DxSearchPanel :visible="false"/>
                            <DxColumn data-field="detail" cell-template="detail-cell-template" alignment="center" :allow-exporting="false" :width="45"/> 
                            <DxColumn data-field="invoice_date" :caption="$t('record_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="record-date-header"/>
                            <DxColumn data-field="invoice_type_name" :caption="$t('invoice_type')" header-cell-template="invoice-type-header" cell-template="invoice_type_name-cell-template"/>
                            <DxColumn data-field="invoice_no" :caption="$t('invoice_number')" header-cell-template="invoice-number-header" />
                            <DxColumn data-field="account_name" :caption="$t('account')" />
                            <DxColumn data-field="account_number" :caption="$t('registration_number')" header-cell-template="account-number-header" />
                            <DxColumn data-field="gross_amount" :sorting-method="this.$numericSort" :caption="$t('grand_total')" header-cell-template="grand-total-header" alignment="right" />
                            <DxColumn data-field="rate" :caption="$t('rate')" alignment="right" />
                            <DxColumn data-field="gross_amount_local" :sorting-method="this.$numericSort" :caption="$t('grand_total_local')" header-cell-template="grand-total-local-header" alignment="right" />
                            <DxColumn data-field="closed_amount" :sorting-method="this.$numericSort" :caption="$t('closed_amount')" alignment="right" header-cell-template="closed-amount-header" />
                            <DxColumn data-field="remain_amount" :sorting-method="this.$numericSort" :caption="$t('remain_amount')" alignment="right" header-cell-template="remain-amount-header" />
                            <DxColumn data-field="closed_amount_local" :sorting-method="this.$numericSort" :caption="$t('closed_amount_local')" header-cell-template="closed-amount-local-header" alignment="right" />
                            <DxColumn data-field="remain_amount_local" :sorting-method="this.$numericSort" :caption="$t('remain_amount_local')" header-cell-template="remain-amount-local-header" alignment="right" />
                            <DxColumn data-field="sales_type_name" :caption="$t('sales_type')" alignment="left" header-cell-template="sales-type-header" />

                            <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur -->
                            <template #headerLocalTemplate="{ data: data }">
                                <div v-html="setColumnTemplateForLocal(data)"></div>
                            </template>

                            <template #record-date-header>
                                <div>{{ $t('record_date') }}</div>
                            </template>
                            <template #invoice-type-header>
                                <div>{{ $t('invoice_type') }}</div>
                            </template>
                            <template #sales-type-header>
                                <div>{{ $t('sales_type') }}</div>
                            </template>
                            <template #invoice-number-header>
                                <div>{{ $t('invoice_number') }}</div>
                            </template>
                            <template #grand-total-header>
                                <div>{{ $t('grand_total') }}</div>
                            </template>
                            <template #closed-amount-header>
                                <div>{{ $t('closed_amount') }}</div>
                            </template>
                            <template #remain-amount-header>
                                <div>{{ $t('remain_amount') }}</div>
                            </template>
                            <template #account-number-header>
                                <div>{{ $t('registration_number') }}</div>
                            </template>

                            <!-- Cell Templates -->
                            <template #detail-cell-template="{ data }">
                                    <a href="#" class="btn btn-sm btn-icon text-hover-primary w-20px h-20px" 
                                        @click="onOpenAccountReport(data.data)" data-bs-toggle="modal" data-bs-target="#kt_modal_invoice_report_stock_transactions" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                        <i class="fa fa-eye text-gray-600 fs-3"></i>
                                    </a>
                                </template>
                            <template #invoice_type_name-cell-template="{ data }">
                                <a href="#" class="text-gray-800 text-hover-primary">
                                    <div>
                                        <span class="fw-bolder" :class="{ 'text-danger': data.data.invoice_type == 4 || data.data.invoice_type == 3 }">
                                            {{ data.data.invoice_type_name }}
                                        </span>
                                    </div>
                                </a>
                            </template>

                            <DxSummary :calculate-custom-summary="setSummaries">
                                <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="invoice_date"/>
                                <DxGroupItem :show-in-group-footer="true" name="gross_amount" summary-type="custom" show-in-column="gross_amount" display-format="{0}" />
                                <DxTotalItem name="gross_amount" summary-type="custom" show-in-column="gross_amount" display-format="{0}" />
                                <DxGroupItem :show-in-group-footer="true" name="gross_amount_local" summary-type="custom" show-in-column="gross_amount_local" display-format="{0}" />
                                <DxTotalItem name="gross_amount_local" summary-type="custom" show-in-column="gross_amount_local" display-format="{0}" />
                                <DxGroupItem :show-in-group-footer="true" name="closed_amount_local" summary-type="custom" show-in-column="closed_amount_local" display-format="{0}" />
                                <DxTotalItem name="closed_amount_local" summary-type="custom" show-in-column="closed_amount_local" display-format="{0}" />
                                <DxGroupItem :show-in-group-footer="true" name="remain_amount_local" summary-type="custom" show-in-column="remain_amount_local" display-format="{0}" />
                                <DxTotalItem name="remain_amount_local" summary-type="custom" show-in-column="remain_amount_local" display-format="{0}" />
                            </DxSummary>
                            <DxStateStoring :enabled="true" type="custom" :storage-key="this.storageKey" :ref="dataGrid"  :saving-timeout="1000" :custom-load="LoadDXState" />
                        </DxDataGrid>
                    </div>
                </div> 
            </div>
        </div> 
    </div> 
    <!-- AccountReportDetailList -->
    <div class="modal fade" id="kt_modal_invoice_report_stock_transactions" tabindex="-1" role="dialog" aria-modal="true"  data-bs-backdrop="static" style="display : none" data-bs-keyboard="false">
        <AccountReportDetailList  ref="AccountReportDetailList"  />
    </div> 
  </div>  
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxGroupItem } from 'devextreme-vue/data-grid';
export default {
    name: "InvoiceReportList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxGroupItem
    }, 
    data() {
        return {
            storageKey: 'dx_' + this.$options.name,
            pageSize: 100,
            page_size: 20,
            lists: [],  
            detailList: [],
            searchbar: '',
            form: {
                report_type: '1',
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                invoice_type: 0,
                currency: '-1',
                account_id: '-1',
                vendor_id: '-1',
                remain_status: 1
            },
            menuSelection: '/CollectionHelppage',
            iconView : false,
            isListProgressing: false,
            dateTypeList: [
                { id: 1, text: this.$t('due_date')},
                { id: 2, text: this.$t('record_date')},
            ],
            isRemainStatusList: [
                { id: 1, text: this.$t('all')},
                { id: 2, text: this.$t('with_remain')},
                { id: 3, text: this.$t('no_remain')},
            ],
            reportTypes: [{ id: '1', text: this.$t('general')}, { id: '2', text: this.$t('date_range')}],
            invoiceTypeList:[
                { id: 0, text: this.$t('all') },
                { id: 1, text: this.$t('outgoing') },  /* Sales Invoice, Purchase Return Invoice*/
                { id: 2, text: this.$t('incoming') },  /* Purchase Invoice, Sales Return Invoice */
                // { id: 1, text: this.$t('sales_invoice') },
                // { id: 2, text: this.$t('purchase_invoice') },
                // { id: 3, text: this.$t('sales_return_invoice') },
                // { id: 4, text: this.$t('purchase_return_invoice') }
            ],
            currencyList: [],
            accountList:[],
            salesVendorList: [],
            localCurrency: null,
        };
    },
    computed: {
        searchableList() {
            return this.lists.filter(p => { 
                return p.account_name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1;
            });
        },
        previewDate(){
            return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
                }
            }
        },
        showPageSizeSelectorLists() {
            return this.lists.length > this.pageSize;
        },
        pageSizesLists() {
            let arr = [];
            let x = 1;
            let loop = (this.lists.length / this.pageSize);
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(1000);
            if(loop > 1) arr.push('all');
            return arr;
        },
        setColumnTemplateForLocal(){
            return (value)=>{
                const captionValue = value.column.caption.replace(this.$t('local'), ' ');
                return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);
            }
        },
    },
    methods: {
        getLists(){
            this.localCurrency = this.$getUser().currency_code;
            const parameters ={
                session_id: this.$getUser().session_id,
                account_type: 12 // Customer + Supplier
            };
            const parametersTwo = {
                session_id: this.$getUser().session_id,
                supplier_account_type: 3, //Sales Vendors
            };  
            const parametersThree = {
                session_id: this.$getUser().session_id,
                list_name: ["currency"]
            };
            const requestOne =  axios.post('/api/CompanyAccounts/GetAccounts', parameters, {'Content-Type': 'application/json'});
            const requestTwo =  axios.post('/api/GetCompanyAccounts/GetPolicyAccounts', parametersTwo, {'Content-Type': 'application/json'});
            const requestThree =  axios.post('/api/Helper/GeneralLists', parametersThree, {'Content-Type': 'application/json'});
            axios.all([requestOne, requestTwo, requestThree]).then(axios.spread((...responses) => {
                this.accountList = responses[0].data.account_data;
                this.accountList.forEach(element => {
                    element.name = this.$unlock(element.name);
                    element.account_id = this.$unlock(element.account_id);
                    element.text = this.$unlock(element.text);
                });
                this.salesVendorList = responses[1].data;
                this.currencyList = responses[2].data.currency;
                this.accountList.unshift({ id: '-1', text: this.$t('all') });
                this.salesVendorList.unshift({ id: '-1', text: this.$t('all') });
                this.currencyList.unshift({ id: '-1', text: this.$t('all')});
            }))
            .catch(errors => { 
                console.error(errors); 
            }); 
        },
        getData() {
            this.lists = [];
            this.isListProgressing = true;
            this.$Progress.start();
            this.form.first_date = (this.form.first_date == null || this.form.first_date == '') ? moment() : this.form.first_date;
            this.form.last_date = ( this.form.last_date == null || this.form.last_date == '') ? moment () : this.form.last_date;
            const queryParameter = {         
                session_id: this.$getUser().session_id,
                start_date: moment(this.form.start_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                end_date: moment(this.form.end_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                report_type: this.form.report_type,
                invoice_type: this.form.invoice_type,
                account_id: this.form.account_id == '-1' ? null : this.form.account_id,
                vendor_id: this.form.vendor_id == '-1' ? null : this.form.vendor_id,
                currency: (this.form.currency !== '-1') ? this.form.currency : null,
                remain_status: this.form.remain_status
            };   
            const that = this;
            axios.post('/api/CollectionList/GetInvoiceListReport', queryParameter, {'Content-Type': 'application/json'}) 
            .then((response) => {  
                this.lists = response.data; 
                this.$Progress.finish();
            })
            .catch(() => {
                that.isListProgressing = false;
                this.$Progress.finish();
            })
            .finally(function() {
                that.isListProgressing = false;
                that.$Progress.finish();
            });
        },
        setCriteriasToDefault() {   
            this.form = {
                report_type: '1',
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                invoice_type: 0,
                currency: '-1',
                account_id: '-1',
                vendor_id: '-1',
                remain_status: 1
            };
            this.lists = [];
        },
        /** DX STATE OPERATIONS **/  
        LoadDXState() {
            return JSON.parse(sessionStorage.getItem(this.storageKey));
        }, 
        async helpPageViewIcon()
        {
            const queryparameter = {
                session_id : this.$getUser().session_id,
                menu_selection : '/CollectionHelppage'
            };
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(!response.data.error){ 
                    this.iconView = response.data;
                }
            })
        }, 
        setSummaries(options){  
            const optionNames = ["gross_amount", "gross_amount_local", "remain_amount_local", "closed_amount_local"]; 
            optionNames.forEach(item => {
                if(options.name == item){
                    if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                    else if(options.summaryProcess === 'calculate'){
                        var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                        (options.totalValue += itemValue);
                    }
                    else if(options.summaryProcess === 'finalize'){ 
                        options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                    }
                }
            });
        },
        onCustomizeColumn(e){
            if(e){
                if(!e._isUpdated){
                    if(e.length > 0){ 
                        e._isUpdated = true;
                    }
                    e.forEach((column) => {
                        if(column.dataField == 'gross_amount_local'){ 
                            column.caption = this.$t('local_grand_total');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                        if(column.dataField == 'closed_amount_local'){ 
                            column.caption = this.$t('local_closed_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                        if(column.dataField == 'remain_amount_local'){ 
                            column.caption = this.$t('local_remain_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                    });  
                } 
            } 
        },
        onOpenAccountReport(item){
            this.$refs.AccountReportDetailList.getData(item.id);
        },
    },
    created() {
        this.getLists();
        this.helpPageViewIcon();
        this.lists = [];
        this.$removeSessionStorage('record_id');
    }
}; 
</script>